import type { ItemDependency } from '@/common/api/types/items';

export type NormalizedDependency = {
  dependencyType: ItemDependency['dependencyType'];
  dependencyItemId: number;
  inherited: boolean;
};

export function selectPanelDependencies(dependencies: ItemDependency[]): NormalizedDependency[] {
  return dependencies.map((dep) => ({
    dependencyType: dep.dependencyType,
    dependencyItemId: dep.dependencyItemId,
    inherited: dep.inherited === true,
  }));
}

export const toInheritedItemIds = (dependencies: NormalizedDependency[]): Set<number> =>
  new Set(dependencies.filter((dep) => dep.inherited).map((dep) => dep.dependencyItemId));
